import type React from 'react';

export interface BottomSheetProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

export function BottomSheet({ isOpen, onClose, children }: BottomSheetProps) {
  return (
    <>
      {/* Backdrop */}
      <div
        className="absolute inset-0 z-[30] transition-opacity duration-300"
        style={{
          background: 'rgba(0,0,0,0.4)',
          opacity: isOpen ? 1 : 0,
          pointerEvents: isOpen ? 'auto' : 'none',
          backdropFilter: 'blur(4px)',
          WebkitBackdropFilter: 'blur(4px)',
        }}
        onClick={onClose}
      />
      {/* Panel */}
      <div
        className="absolute bottom-0 left-0 right-0 z-[31] transition-transform duration-300 ease-out sheet-inverted"
        style={{
          transform: isOpen ? 'translateY(0)' : 'translateY(100%)',
          borderRadius: 20,
          background: 'var(--t-bg)',
          maxHeight: '70%',
          overflow: 'visible',
          marginBottom: 12,
          marginLeft: 12,
          marginRight: 12,
        }}
      >
        {children}
      </div>
    </>
  );
}
